<template>
  <validation-observer ref="interventionPlanObjetive">
    <div class="row mt-2 align-items-center">
      <div class="col-12 mb-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            id="comment"
            v-model="objetive.description"
            class="objetive-container__text-area"
            :count-classes="['d-block', 'small-counter']"
            custom-error-msg="Favor escribir una descripción del objetivo."
            :error="errors[0]"
            label="Añadir Objetivo:"
            :maxlength="3000"
            name="comment"
            show-char-count
          />
        </validation-provider>
      </div>
      <div class="col-12 col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="objetive.measurement"
            class="dropdown"
            :clearable="false"
            custom-error-msg="Favor seleccione el tipo de medición."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Medición:"
            :options="measurement"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div v-if="isPercentSelected" class="col-12 col-md-3">
        <validation-provider
          v-slot="{ errors }"
          rules="required|differentFromZero|greaterThanZero|max_value:100"
        >
          <custom-input
            v-model="objetive.percent"
            custom-error-msg="Porcentaje debe ser entre 1 y 100."
            :error="errors[0]"
            label="Porcentaje:"
            type="number"
            @input="validateNumFormat('percent')"
          />
        </validation-provider>
      </div>
      <div v-else-if="isAttempt" class="col-5 col-md-2 mt-2 mt-md-auto">
        <validation-provider
          v-slot="{ field, errors }"
          name="Desde"
          :rules="
            `required|differentFromZero|greaterThanZero|max_value:${objetive.measureAmt2}`
          "
        >
          <custom-input
            v-model="objetive.measureAmt1"
            v-bind="field"
            :error="errors[0]"
            type="number"
            @input="validateNumFormat('measureAmt1')"
          />
        </validation-provider>
      </div>
      <div v-if="isAttempt" class="col-2 col-md-1 mt-auto text-center">de</div>
      <div v-if="isAttempt" class="col-5 col-md-2 mt-auto">
        <validation-provider
          v-slot="{ errors }"
          name="Hasta"
          :rules="
            `required|differentFromZero|greaterThanZero|min_value:${objetive.measureAmt1}`
          "
        >
          <custom-input
            v-model="objetive.measureAmt2"
            :error="errors[0]"
            type="number"
            @input="validateNumFormat('measureAmt2')"
          />
        </validation-provider>
      </div>
      <div
        class="col-12 col-md-3 ml-auto align-self-stretch mt-md-auto mt-3 d-md-flex justify-content-end"
      >
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 mb-2 mb-md-0"
          @click="cancel"
        />

        <action-button
          i="fa fa-save"
          text="Añadir"
          variant="success"
          @click="saveObjetive"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import interventionPlanMeasure from '@/utils/constants/interventionPlanMeasure.js';

export default {
  name: 'ObjetiveForm',
  components: {
    CustomDropDown,
    CustomTextArea,
    CustomInput,
    ActionButton,
  },
  props: {
    model: {
      type: Object,
      default: () => null,
    },
    measurement: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    objetive: {
      description: null,
      measurement: null,
      measureAmt1: 0,
      measureAmt2: 0,
      percent: 0,
    },
    isEditing: false,
  }),
  computed: {
    isPercentSelected() {
      return this.objetive.measurement?.id == interventionPlanMeasure.Percent;
    },
    isAttempt() {
      return this.objetive.measurement?.id == interventionPlanMeasure.Attempt;
    },
  },
  watch: {
    model: {
      immediate: true,
      handler(current) {
        if (current) {
          const measureId = current.measureCodeId || current.measurement.id;
          this.objetive = {
            ...current,
            measurement: this.measurement.find((m) => m.id == measureId),
            percent: this.model.percent,
          };
          this.isEditing = true;
        }
      },
    },
  },
  methods: {
    cancel() {
      const event = this.isEditing ? 'cancel-update' : 'cancel-add';
      this.$emit(event);
    },
    async saveObjetive() {
      const isValid = await this.$refs.interventionPlanObjetive.validate();
      if (!isValid) return;

      const event = this.isEditing ? 'edit-objetive' : 'save-objetive';
      this.$emit(event, this.objetive);
    },
    validateNumFormat(type = 'percent') {
      if (type === 'percent') {
        if (this.objetive.percent === null || this.objetive.percent === 0)
          return;

        let str = this.objetive.percent.toString();

        if (/^0[1-9]$/.test(str)) {
          str = str.replace(/^0+/, '');
        }

        if (/^0+\d+$/.test(str)) {
          str = str.replace(/^0+/, '');
        }

        this.objetive.percent = str;
      } else if (type === 'measureAmt1') {
        if (
          this.objetive.measureAmt1 === null ||
          this.objetive.measureAmt1 === 0
        )
          return;

        let str = this.objetive.measureAmt1.toString();

        if (/^0[1-9]$/.test(str)) {
          str = str.replace(/^0+/, '');
        }

        if (/^0+\d+$/.test(str)) {
          str = str.replace(/^0+/, '');
        }

        this.objetive.measureAmt1 = str;
      } else if (type === 'measureAmt2') {
        if (
          this.objetive.measureAmt2 === null ||
          this.objetive.measureAmt2 === 0
        )
          return;

        let str = this.objetive.measureAmt2.toString();

        if (/^0[1-9]$/.test(str)) {
          str = str.replace(/^0+/, '');
        }

        if (/^0+\d+$/.test(str)) {
          str = str.replace(/^0+/, '');
        }

        this.objetive.measureAmt2 = str;
      }
    },
  },
};
</script>
